<template>
  <modal
    title="Add New Job Level"
    width="35"
    :showModal="showModal"
    @close-modal="closeModal"
  >
    <p class="font-medium">Which of these best describe the job level?</p>
    <div class="job-level__type__options pt-3">
          <div
            class="single-option"
            v-for="jobLevel in jobLevels"
            :key="jobLevel.id"
          >
            <label :for="jobLevel.id" class="radio-label">
              <input
                type="radio"
                :id="jobLevel.id"
                :value="jobLevel.id"
                v-model="newLevel.level.categoryId"
              />
              {{ jobLevel.name }}
              <span></span>
            </label>
          </div>
        </div>
    <hr class="my-2" />
    <p class="font-medium">Job Level Details</p>
    <div class="input-wrapper my-2">
      <label for="levelId" class="">Level ID</label>
      <input
        type="text"
        id="levelId"
        class="input"
        v-model="newLevel.level.name"
      />
    </div>
    <div class="input-wrapper">
      <label for="cost-center" class="">Tags</label>
      <!-- <input type="text" id="cost-center" class="input" /> -->
      <el-select multiple v-model="selectedTagIds"  placeholder="Select">
        <el-option
          v-for="tag in tags"
          :key="tag.id"
          :label="tag.name"
          :value="tag.id"
        >
        </el-option>
      </el-select>
    </div>

    <div class="button-wrapper mt-5">
      <primary-button buttonText="Save" @click="createJobLevel" :loading="creatingJobLevel"/>
      <p class="cursor-pointer pt-2 pr-3 mb-0" @click="closeModal">Close</p>
    </div>
  </modal>
</template>

<script>
export default {
  props: ["showModal"],
  data() {
    return {
      newLevel: {
        level: {
          name: "",
          categoryId: "",
          levelTags: [],
          tags: ''
        },
      tags: [],
      },
      selectedTagIds: [],
      managementLevel: "top",
      creatingJobLevel: false,
      jobLevels: [],
      tags: [],
    };
  },
  mounted() {
    this.getAllTags();
    this.getJobLevels();
  },
  methods: {
    async createJobLevel() {
      this.creatingJobLevel = true;
      this.createTagObject();
      try {
        let response = await this.$_createJobLevel(this.newLevel);
        console.log(response);
        this.generateToast("Job level successfully created!", "success");
        this.resetInputs();
        this.creatingJobLevel = false;
        this.$router.push({ name: "OrganizationHierarchy" });
      } catch (error) {
        this.handleError(error);
        this.creatingJobLevel = false;
      }
    },
    async getJobLevels() {
      try {
        let response = await this.$_getDefaultJobLevels();
        console.log(response, "cate   ");
        this.jobLevels = response.data.categories;
      } catch (error) {
        this.handleError(error);
      }
    },
    async getAllTags() {
      try {
        let response = await this.$_getAllTags();
        console.log(response,"tags");
        this.tags = response.data.tags;
      } catch (error) {
        this.handleError(error);
      }
    },
    resetInputs() {
      this.newLevel = {
        level: {
          name: "",
          categoryId: "",
          levelTags: [],
        },
      };
      this.selectedTagIds = [];
    },
    createTagObject() {
      let tagIds = [];
      this.selectedTagIds.forEach((id) => {
        let tagIdObject = {};
        tagIdObject.tagId = id;
        tagIds.push(tagIdObject);
      });
      this.newLevel.level.levelTags = tagIds;
    },
    closeModal() {
      this.$emit("close-modal");
    },
  },
};
</script>

<style scoped>
.row {
  padding-top: 1rem !important;
}
.kpa-summary {
  margin-top: 1rem;
}
.text-grey {
  color: #7a90a7;
}
li {
  list-style-type: initial !important;
  margin-left: 1rem;
  padding-top: 0.5rem;
}
</style>
